module.exports = __webpack_public_path__ + "img/map@2x.905b64ac.png";